import { IFile } from '@sdk/contracts';
import { Image } from 'antd';
import isEmpty from 'lodash/isEmpty';

import DeleteUpload from '../DeleteUpload/DeleteUpload';

import { UploadItem } from './UploadPreview.style';

import { AudioPlayer } from '@/components/AudioPlayer';
import { Icon } from '@/components/Icon';
import { VideoPlayer } from '@/components/VideoPlayer';
import { isImage, isVideo, isAudio } from '@/utils';

type PreviewProps = {
  files: IFile[];
  isMultiple?: boolean;
  width: number | string;
  height: number | string;
  onDelete?: (fileId: string) => void;
  deleteMode?: 'delete' | 'unlink';
};

const getFileTypeIcon = (file: IFile) => {
  const { mimetype } = file;
  if (isImage(mimetype)) return 'Image';
  if (isVideo(mimetype)) return 'Video';
  if (isAudio(mimetype)) return 'Radio';
  return 'Document';
};

const UploadPreview: React.FC<PreviewProps> = ({
  files,
  isMultiple,
  width,
  height,
  onDelete,
  deleteMode
}) => {
  if (!files || isEmpty(files)) return null;

  if (!isMultiple) {
    const file = files.find(f => f?.mimetype);
    if (!file) return <></>;

    const { mimetype, url } = file;

    if (isImage(mimetype))
      return (
        <>
          <Image
            width={width}
            src={url}
            height={height}
            preview={false}
            className="upload-preview"
            style={{ objectFit: 'cover' }}
          />
          {onDelete && <DeleteUpload file={file} onDelete={onDelete} deleteMode={deleteMode} />}
        </>
      );

    if (isVideo(mimetype)) {
      return (
        <>
          <VideoPlayer file={file} />
          {onDelete && <DeleteUpload file={file} onDelete={onDelete} deleteMode={deleteMode} />}
        </>
      );
    }
    if (isAudio(mimetype))
      return (
        <>
          <AudioPlayer file={file} />
          {onDelete && <DeleteUpload file={file} onDelete={onDelete} deleteMode={deleteMode} />}
        </>
      );
  }

  return (
    <>
      {files
        .filter(f => !!f)
        .map(f => (
          <UploadItem key={`_${f._id}`}>
            <Icon i={getFileTypeIcon(f)} />
            <div> {f.name}</div>
            {onDelete && (
              <DeleteUpload isMultiple file={f} onDelete={onDelete} deleteMode={deleteMode} />
            )}
          </UploadItem>
        ))}
    </>
  );
};

export default UploadPreview;
